import CartItem from './CartItem';
import Product from './Product';

export default class Cart {

    constructor(items) {
        this.items = items;
    }

    add(cartItem) {
        const existingItem = this.items.find((existingCartItem) => existingCartItem.product.id === cartItem.product.id);

        if(typeof existingItem === 'undefined') {
            this.items.push(cartItem);

            return;
        }

        existingItem.update({
            quantity: existingItem.quantity + 1
        });
    }

    remove(key) {
        this.items.splice(key, 1);
    }

    getSubtotal() {
        let price = 0;

        for(let i in this.items) {
            price+= this.items[i].price;
        }

        return price;
    }

    getPrice() {
        let price = 0;

        for(let i in this.items) {
            price+= this.items[i].price + (this.items[i].price * (this.items[i].product.vatPercentage / 100));
        }

        return price + this.getShipping() + (this.getShipping() * 0.09);
    }

    getQuantity() {
        let quantity = 0;

        for(let item of this.items) {
            quantity+= item.quantity;
        }

        return quantity;
    }

    getVat() {
        return (this.getPrice() - (this.getSubtotal() + this.getShipping()))
    }

    getShipping() {
        const subtotal = this.getSubtotal();

        switch(true) {
            case (subtotal > 470):
                return 40.50;

            case(subtotal <= 470 && subtotal > 350):
                return 27;

            case(subtotal <= 350 && subtotal > 190):
                return 13.50;

            case(subtotal <= 190 && subtotal > 23.75):
                return 8;

            case(subtotal <= 23.75 && subtotal > 4.75):
                return 5.45;

            case(subtotal === 0):
                return 0;

            default:
                return 4.25;
        }
    }

    parsePrice(price) {
        return parseFloat(price).toFixed(2).replace(/\./, ',').replace(/,00/, ',-')
    }

    static makeFromJson(cart) {
        if(cart.items) {
            return new Cart(cart.items.map((item) => {
                item.product = Product.getById(item.product.id);
                const cartItem =  new CartItem(item);
                cartItem.refresh();

                return cartItem;
            }));
        }
    }
}
